import styled from "styled-components";

export const Container = styled.span`
	display: flex;
	flex-direction: column;
	gap: 40px;
`;

export const TitlePart = styled.h5``;

export const Content = styled.div`
	display: flex;
	flex-direction: row;
`;

export const BoxPart = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 10px;
	flex: 1;
`;

export const BoxImagePart = styled.div`
	img {
		width: 100%;
		max-width: 75px;
		max-height: 75px;
		min-width: 75px;
		min-height: 75px;
		object-fit: contain;
	}
`;
export const BoxText = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	max-width: 200px;
`;

export const TextPart = styled.span``;
export const Quantity = styled.div`
	border: 1px solid ${({ theme }) => theme.pantone2726C};
	width: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 20%;
`;

export const WrapperQuantity = styled.div`
	width: 100%;
	max-width: 30px;
`;
